/* eslint-disable import/no-unresolved */
import aesopDarkTheme from './aesop/dark.json'
import aesopLightTheme from './aesop/light.json'
import avonDarkTheme from './avon/dark.json'
import avonLightTheme from './avon/light.json'
import avonV2DarkTheme from './avon_v2/dark.json'
import avonV2LightTheme from './avon_v2/light.json'
import avonV3DarkTheme from './avon_v3/dark.json'
import avonV3LightTheme from './avon_v3/light.json'
import biomeDarkTheme from './biome/dark.json'
import biomeLightTheme from './biome/light.json'
import naturaDarkTheme from './natura/dark.json'
import naturaLightTheme from './natura/light.json'
import naturaV2DarkTheme from './natura_v2/dark.json'
import naturaV2LightTheme from './natura_v2/light.json'
import naturaV3DarkTheme from './natura_v3/dark.json'
import naturaV3LightTheme from './natura_v3/light.json'
import theBodyShopDarkTheme from './theBodyShop/dark.json'
import theBodyShopLightTheme from './theBodyShop/light.json'
import consultoriaDeBelezaDarkTheme from './consultoriaDeBeleza/dark.json'
import consultoriaDeBelezaLightTheme from './consultoriaDeBeleza/light.json'
import consultoriaDeBelezaV2DarkTheme from './consultoriaDeBeleza_v2/dark.json'
import consultoriaDeBelezaV2LightTheme from './consultoriaDeBeleza_v2/light.json'
import casaEestiloDarkTheme from './casaEestilo/dark.json'
import casaEestiloLightTheme from './casaEestilo/light.json'
import casaEestiloV2DarkTheme from './casaEestilo_v2/dark.json'
import casaEestiloV2LightTheme from './casaEestilo_v2/light.json'
import forcaDeVendasDarkTheme from './forcaDeVendas/dark.json'
import forcaDeVendasLightTheme from './forcaDeVendas/light.json'
import forcaDeVendasV2DarkTheme from './forcaDeVendas_v2/dark.json'
import forcaDeVendasV2LightTheme from './forcaDeVendas_v2/light.json'

const themes = {
  aesop: {
    dark: aesopDarkTheme,
    light: aesopLightTheme
  },
  avon: {
    dark: avonDarkTheme,
    light: avonLightTheme
  },
  avon_v2: {
    dark: avonV2DarkTheme,
    light: avonV2LightTheme
  },
  avon_v3: {
    dark: avonV3DarkTheme,
    light: avonV3LightTheme
  },
  biome: {
    dark: biomeDarkTheme,
    light: biomeLightTheme
  },
  natura: {
    dark: naturaDarkTheme,
    light: naturaLightTheme
  },
  natura_v2: {
    dark: naturaV2DarkTheme,
    light: naturaV2LightTheme
  },
  natura_v3: {
    dark: naturaV3DarkTheme,
    light: naturaV3LightTheme
  },
  theBodyShop: {
    dark: theBodyShopDarkTheme,
    light: theBodyShopLightTheme
  },
  consultoriaDeBeleza: {
    dark: consultoriaDeBelezaDarkTheme,
    light: consultoriaDeBelezaLightTheme
  },
  consultoriaDeBeleza_v2: {
    dark: consultoriaDeBelezaV2DarkTheme,
    light: consultoriaDeBelezaV2LightTheme
  },
  casaEestilo: {
    dark: casaEestiloDarkTheme,
    light: casaEestiloLightTheme
  },
  casaEestilo_v2: {
    dark: casaEestiloV2DarkTheme,
    light: casaEestiloV2LightTheme
  },
  forcaDeVendas: {
    dark: forcaDeVendasDarkTheme,
    light: forcaDeVendasLightTheme
  },
  forcaDeVendas_v2: {
    dark: forcaDeVendasV2DarkTheme,
    light: forcaDeVendasV2LightTheme
  }
}

export default themes
